import tracking, { EVENT_KEY, globalTracking } from 'src/config/tracking/index.js'

const trackingUtils = {
  trackGlobalFeatureUse ({ action, feature, entity, ...rest }) {
    globalTracking.addEvent(EVENT_KEY.FEATURE_USE, {
      action,
      app: 'SDUI',
      feature,
      entity,
      ...rest
    })
  },

  track (type, params = {}) {
    const { trackGlobal, ...rest } = params
    if (trackGlobal) this.trackGlobalFeatureUse({ feature: trackGlobal.feature, ...rest })
    return tracking.addEvent(type, { ...rest })
  },

  trackWithResult (eventType, params = {}) {
    const payload = { result: params.result }
    const { trackGlobal, failedReason, ...rest } = params
    if (failedReason) payload.failedReason = failedReason
    if (trackGlobal) this.trackGlobalFeatureUse({ feature: trackGlobal.feature, ...rest })
    return tracking.addEvent(eventType, { ...payload, ...rest })
  },

  fetchRemoteConfig (key) {
    if (!key) {
      console.warn('fetchRemoteConfig called with invalid key:', key)
      return
    }
    return tracking.fetchConfig(key)
  },

  showAIChatSurvey () {
    return tracking.reportFeedback({ widgetId: import.meta.env.VITE_COUNTLY_SURVEY_AI_CHAT_ID, selectorId: 'app-wrapper' })
  },

  showAIProofReadSurvey () {
    return tracking.reportFeedback({ widgetId: import.meta.env.VITE_COUNTLY_SURVEY_AI_NEWS_FEEDBACK_ID, selectorId: 'app-wrapper' })
  },

  showNewsCreationSurvey () {
    return tracking.reportFeedback({ widgetId: import.meta.env.VITE_COUNTLY_SURVEY_NEWS_CREATION_FEEDBACK_ID, selectorId: 'app-wrapper' })
  },

  closeFeedbackSurvey ({ widgetId }) {
    return tracking.closeSurvey({ widgetId })
  }
}

export default trackingUtils
